import { render, staticRenderFns } from "./viewInvoice.vue?vue&type=template&id=16e6125a&"
import script from "./viewInvoice.vue?vue&type=script&lang=js&"
export * from "./viewInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports